import { render, staticRenderFns } from "./StepTemplatesList.vue?vue&type=template&id=d972f164&scoped=true&"
import script from "./StepTemplatesList.vue?vue&type=script&lang=js&"
export * from "./StepTemplatesList.vue?vue&type=script&lang=js&"
import style0 from "./StepTemplatesList.vue?vue&type=style&index=0&id=d972f164&scoped=true&lang=css&"
import style1 from "./StepTemplatesList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d972f164",
  null
  
)

export default component.exports